module.exports = __webpack_public_path__ + "static/media/cert_9001.cf358bdf.pdf";